var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"24","height":"24","rx":"12","fill":"#38DDCC","key":0}),React.createElement("path",{"d":"M16 9L10.5 14.5L8 12","stroke":"#1A033B","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Check.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Check;

Check.default = Check;
